export * from './honorar-vereinbarung-gespeichert.interface';
